// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentful-asset {
  position: relative;
  margin-bottom: 10px; }
  .contentful-asset > img {
    border: 1px solid #DDD; }
  .contentful-asset > video {
    display: block;
    width: 100%;
    height: auto;
    border: 1px solid #DDD;
    border-bottom: none; }
  .contentful-asset.contentful-asset-toolbar-overlayed > .contentful-asset-toolbar {
    position: absolute;
    bottom: 1px;
    left: 1px;
    right: 1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0; }
  .contentful-asset.contentful-asset-toolbar-bottom > .img-rounded {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: none; }
  .contentful-asset.contentful-asset-toolbar-bottom > .contentful-asset-toolbar {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border: 1px solid #DDD;
    border-top: none; }

.contentful-asset-toolbar {
  display: flex;
  flex-wrap: wrap;
  background-color: #f5f5f5;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  border: 1px solid #e3e3e3;
  border-radius: 5px; }
  .contentful-asset-toolbar.contentful-asset-toolbar-inverse {
    background-color: #333;
    color: #DDD;
    box-shadow: none;
    border: none; }
    .contentful-asset-toolbar.contentful-asset-toolbar-inverse .btn-link {
      color: inherit; }
  .contentful-asset-toolbar > .contentful-asset-title,
  .contentful-asset-toolbar > .contentful-asset-actions {
    padding: 10px 10px 10px 0px; }
    .contentful-asset-toolbar > .contentful-asset-title:first-child,
    .contentful-asset-toolbar > .contentful-asset-actions:first-child {
      padding-left: 10px; }
  .contentful-asset-toolbar > .contentful-asset-title {
    flex: 1 1 auto;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden; }
    .contentful-asset-toolbar > .contentful-asset-title .contentful-asset-icon {
      font-size: 33px;
      float: left;
      margin-right: 5px; }
    .contentful-asset-toolbar > .contentful-asset-title > p {
      margin: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden; }
      .contentful-asset-toolbar > .contentful-asset-title > p:first-of-type {
        font-weight: bold; }
      .contentful-asset-toolbar > .contentful-asset-title > p:last-of-type {
        margin-top: -1px;
        font-size: 85%; }
  .contentful-asset-toolbar > .contentful-asset-actions {
    flex: 0 0 auto; }
  .contentful-asset-toolbar > .contentful-asset-description {
    flex: 0 0 auto;
    flex-basis: 100%;
    padding: 0 10px; }
`, "",{"version":3,"sources":["webpack://./src/components/contentful/ImageAsset.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB,EAAA;EAFrB;IAKI,sBAAsB,EAAA;EAL1B;IASI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB,EAAA;EAbvB;IAkBM,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;IAEV,yBAAyB;IACzB,0BAA0B,EAAA;EAxBhC;IA8BM,4BAA4B;IAC5B,6BAA6B;IAC7B,mBAAmB,EAAA;EAhCzB;IAoCM,yBAAyB;IACzB,0BAA0B;IAE1B,sBAAsB;IACtB,gBAAgB,EAAA;;AAKtB;EACE,aAAa;EACb,eAAe;EAEf,yBAAyB;EACzB,+CAA+C;EAC/C,yBAAyB;EACzB,kBAAkB,EAAA;EAPpB;IAUI,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,YAAY,EAAA;IAbhB;MAgBM,cAAc,EAAA;EAhBpB;;IAsBI,2BAA2B,EAAA;IAtB/B;;MAyBM,kBAAkB,EAAA;EAzBxB;IA8BI,cAAc;IAEd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB,EAAA;IAlCpB;MAqCM,eAAe;MACf,WAAW;MACX,iBAAiB,EAAA;IAvCvB;MA2CM,SAAS;MAET,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB,EAAA;MA/CtB;QAkDQ,iBAAiB,EAAA;MAlDzB;QAsDQ,gBAAgB;QAChB,cAAc,EAAA;EAvDtB;IA6DI,cAAc,EAAA;EA7DlB;IAiEI,cAAc;IACd,gBAAgB;IAChB,eAAe,EAAA","sourcesContent":[".contentful-asset {\n  position: relative;\n  margin-bottom: 10px;\n\n  > img {\n    border: 1px solid #DDD;\n  }\n\n  > video {\n    display: block;\n    width: 100%;\n    height: auto;\n    border: 1px solid #DDD;\n    border-bottom: none;\n  }\n\n  &.contentful-asset-toolbar-overlayed {\n    > .contentful-asset-toolbar {\n      position: absolute;\n      bottom: 1px;\n      left: 1px;\n      right: 1px;\n\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n    }\n  }\n\n  &.contentful-asset-toolbar-bottom {\n    > .img-rounded {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n      border-bottom: none;\n    }\n\n    > .contentful-asset-toolbar {\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n\n      border: 1px solid #DDD;\n      border-top: none;\n    }\n  }\n}\n\n.contentful-asset-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n\n  background-color: #f5f5f5;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e3e3e3;\n  border-radius: 5px;\n\n  &.contentful-asset-toolbar-inverse {\n    background-color: #333;\n    color: #DDD;\n    box-shadow: none;\n    border: none;\n\n    .btn-link {\n      color: inherit;\n    }\n  }\n\n  > .contentful-asset-title,\n  > .contentful-asset-actions {\n    padding: 10px 10px 10px 0px;\n\n    &:first-child {\n      padding-left: 10px;\n    }\n  }\n\n  > .contentful-asset-title {\n    flex: 1 1 auto;\n\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n\n    .contentful-asset-icon {\n      font-size: 33px;\n      float: left;\n      margin-right: 5px;\n    }\n\n    > p {\n      margin: 0;\n\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n\n      &:first-of-type {\n        font-weight: bold;\n      }\n\n      &:last-of-type {\n        margin-top: -1px;\n        font-size: 85%;\n      }\n    }\n  }\n\n  > .contentful-asset-actions {\n    flex: 0 0 auto;\n  }\n\n  > .contentful-asset-description {\n    flex: 0 0 auto;\n    flex-basis: 100%;\n    padding: 0 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
